import Url from 'urljs';
import {deserialize} from "deserialize-json-api";
import Paginator from 'headless-pagination';

window.addEventListener('DOMContentLoaded', function () {
    const pagination = document.querySelector("nav.adverts-pagination");

    if (!pagination) return;

    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    const paginationList = pagination.querySelector('ul');
    const pageItemStart = document.querySelector("#page-item-start");
    const pageItemEnd = document.querySelector("#page-item-end");
    const resultsContainer = document.querySelector("#adverts-container");
    const loader = document.querySelector(".loader-overlay");
    const sortDropdown = document.querySelector("#adverts-sort-dropdown");

    let sort = price ? 'price-desc' : "first-seen-at";

    const advertsBlock = document.querySelector("#adverts-block");
    const headerOffset = 90;
    const elementPosition = advertsBlock.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    const params = Url.parseQuery();
    const paginator = new Paginator({
        totalItems: window.total,
        initialPage: +params.page || 1,
        perPage: window.pageSize,
        maxLinks: 7,
    });

    renderPagination(paginator.links());

    // handle browser back/forward buttons
    window.addEventListener('popstate', function (event) {
        const page = +(Url.parseQuery().page || 1);
        paginator.setPage(page);
        renderPagination(paginator.links());
        fetchAndRenderAdverts(page, false);
    }, false);

    function renderPagination(links) {
        paginationList.innerHTML = '';
        const url = location.href.replace(location.search, '');
        const prevBtn = document.createElement('li');
        const prevLink = document.createElement('a');
        const nextBtn = document.createElement('li');
        const nextLink = document.createElement('a');

        prevLink.href = `${url}${paginator.page() < 3 ? '' : '?page=' + (paginator.page() - 1)}`;
        prevLink.innerHTML = '«';
        nextLink.href = `${url}?page=${paginator.page() === paginator.totalPages() ? paginator.totalPages() : paginator.page() + 1}`;
        nextLink.innerHTML = '»';

        if (window.total > 1) {
            pageItemStart.innerHTML = (((paginator.page() - 1) * window.pageSize) + 1).toString();
            const pageItemEndIndex = ((paginator.page() - 1) * window.pageSize) + window.pageSize;
            pageItemEnd.innerHTML = (pageItemEndIndex > window.total ? window.total : pageItemEndIndex).toString();
        } else {
            document.querySelector('#pagination-info').innerHTML = "1 of 1 car";
        }

        if (paginator.page() === 1) prevBtn.classList.add('disabled');
        if (paginator.page() === paginator.totalPages()) nextBtn.classList.add('disabled');

        prevBtn.appendChild(prevLink);
        nextBtn.appendChild(nextLink);

        prevLink.addEventListener('click', (e) => {
            e.preventDefault();
            paginator.onPrevious();
            renderPagination(paginator.links());
            fetchAndRenderAdverts(paginator.page());
        });
        nextLink.addEventListener('click', (e) => {
            e.preventDefault();
            paginator.onNext();
            renderPagination(paginator.links());
            fetchAndRenderAdverts(paginator.page());
        });

        paginationList.appendChild(prevBtn);

        links.forEach(i => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.innerHTML = i.label.toString();
            link.href = `${url}${+i.label === 1 ? '' : '?page=' + i.label}`

            if (i.active && typeof i.label === "number")
                item.classList.add('selected');

            if (i.disabled)
                item.classList.add('disabled');

            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (typeof i.label === "number" && paginator.page() !== i.label) {
                    paginator.setPage(+i.label);
                    renderPagination(paginator.links());
                    fetchAndRenderAdverts(+i.label);
                }
            });

            item.appendChild(link);
            paginationList.appendChild(item);
        });

        paginationList.appendChild(nextBtn);
    }

    function fetchAndRenderAdverts(pageNumber, updateParams = true) {
        loader.classList.toggle('d-none');

        fetchAdverts(
            window.make,
            window.model,
            window.colour,
            window.currentLocation,
            window.price,
            pageNumber,
            sort
        ).then(({data, meta}) => {
            resultsContainer.innerHTML = "";
            data.forEach(ad => {
                resultsContainer.innerHTML += createAdvertCard(ad);
            });

            if (updateParams) {
                if (pageNumber === 1) {
                    Url.removeQuery(true);
                } else {
                    Url.updateSearchParam("page", pageNumber, true);
                }
            }

            window.scrollTo({top: offsetPosition, behavior: "smooth"});
            loader.classList.toggle('d-none');
        }).catch(() => {
            loader.classList.toggle('d-none');
            alert('Error loading adverts!')
        });
    }


    document.querySelector('#edit-filters-btn')?.addEventListener('click', () => {
        if (window.setModalShown) { // react app already injected
            window.setModalShown(true);
            return;
        }

        window.filterDialogCss.forEach(url => {
            const filterDialogStyles = document.createElement('link');
            filterDialogStyles.type = 'text/css';
            filterDialogStyles.rel = 'stylesheet';
            filterDialogStyles.href = url;
            document.head.append(filterDialogStyles);
        });

        window.filterDialogJs.forEach(url => {
            const script = document.createElement('script');
            script.src = url;
            document.body.appendChild(script);
        });
    });

    sortDropdown.addEventListener('change', (e) => {
        sort = e.target.value;
        renderPagination(paginator.links());
        fetchAndRenderAdverts(paginator.page());
    })
});


const token = window.apiToken;
const API_URL = "https://choosemycar.com/api";

async function fetchAdverts(make = null,
                            model = null,
                            colour = null,
                            location = null,
                            price = null,
                            page = 1,
                            sort = "first-seen-at") {
    let params = [];

    if (make) params.push(`filter[make]='${make.replace(/'/g, "\\'")}'`);
    if (model) params.push(`filter[model]='${model.replace(/'/g, "\\'")}'`);
    if (colour) params.push(`filter[colour]='${colour}'`);
    if (location) params.push(`filter[geo.location]='${location}'`);
    if (price) params.push(`filter[price][lte]=${price}`);


    params.push(`page[number]=${page}`);
    params.push(`page[size]=${window.pageSize}`);
    params.push(`sort=${sort === 'price-desc' ? '-price' : sort}`);
    params.push(`filter[last-seen-at][gte]='-3 days'`);

    return deserialize(
        await (
            await (async (endpoint, method = "GET") => {
                return await fetch(`${API_URL}${endpoint}`, {
                    method: method,
                    headers: {
                        'Accept': 'application/vnd.api+json',
                        'Content-Type': 'application/vnd.api+json',
                        'Authorization': 'Bearer ' + token,
                    }
                });
            })(`/adverts/search?${params.join('&')}`))
            .json()
    )
}

function createAdvertCard(advert) {
    return `
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <a href="https://choosemycar.com/vehicle/${advert.id}" class="vehicle-card mx-n2 mx-md-0">
            <div class="vehicle-card-img">
                <img src="${advert.image.medium}" alt="${advert.make.name + ' ' + advert.model.name}" loading="lazy">
            </div>
            <div class="vehicle-info">
                <h4 class="vehicle-name mb-0">${advert.make.name} ${advert.model.name} <br> <span>${advert.variant.name}</span></h4>
                <p class="vehicle-specs mb-0">${advert.year} | ${advert.slugs.transmission} | ${formatNumber(advert.mileage)} miles | ${advert.fuelType.name} </p>
            </div>
        
            <div class="prices">
                <dl class="finance-price">
                    <dt>Finance From</dt>
                    <dd class="price text-primary lh-1">${formatCurrency(Math.round(advert.lowestMonthlyFinanceFrom.pence / 100))}<span>/month</span>
                    </dd>
                </dl>
                <dl class="cash-price">
                    <dt>Cash Price</dt>
                    <dd class="price lh-1">${formatCurrency(advert.price)}
                </dl>
            </div>
        </a>
      </div>
    `
}

function formatCurrency(number) {
    return new Intl.NumberFormat('en-UK', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0
    }).format(number)
}

function formatNumber(number) {
    return new Intl.NumberFormat('en-UK', {maximumFractionDigits: 0}).format(number)
}
